import { REDUCED, VALUE } from "./propertyNames";
export function reduced(result) {
  var _a;

  return _a = {}, _a[REDUCED] = true, _a[VALUE] = result, _a;
}
export function isReduced(result) {
  return result && result[REDUCED] === true;
}
export function ensureReduced(result) {
  return isReduced(result) ? result : reduced(result);
}
export function unreduced(result) {
  return isReduced(result) ? result[VALUE] : result;
}
export function compose() {
  var fs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    fs[_i] = arguments[_i];
  }

  return function (x) {
    var result = x;

    for (var i = fs.length - 1; i >= 0; i--) {
      result = fs[i](result);
    }

    return result;
  };
}